import { ProductUtils } from '@wix/package-picker-shared';
import { useIsStudioNewUi } from '@wix/package-picker-shared-studio';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { BaseProductCard } from './ProductCard/BaseProductCard';
import { ProductCard } from './ProductCard/ProductCard';

const NEW_UI_CARDS_GAP = 12;

export const ProductCards = () => {
  const isStudioNewUi = useIsStudioNewUi();
  const Card = isStudioNewUi ? BaseProductCard : ProductCard;

  return (
    <ProductCardList.Default.Root
      gap={isStudioNewUi ? NEW_UI_CARDS_GAP : undefined}
      width={isStudioNewUi ? '100%' : undefined}
    >
      {({ products }) => {
        const sortedProducts = ProductUtils.sortProducts({ products });

        return sortedProducts.map((product) => {
          if (!product.productId) {
            return null;
          }

          return <Card key={product.productId} productId={product.productId} />;
        });
      }}
    </ProductCardList.Default.Root>
  );
};
